import React from "react";

function IconCloseNotification(props) {

  return (
        <svg
        onMouseOver={() => props.MouseEnter && props.MouseEnter()}
        onMouseLeave={() => props.MouseLeave && props.MouseLeave()}
        onClick={(e) => props.Click && props.Click(e)}
        height={props.height}
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit="2"
        clipRule="evenodd"
        viewBox="0 0 180 180"
        style={{verticalAlign: "middle"}}
        >
        <path
            
            className={props.pathClass ? props.pathClass : "g1-fill"}
            d="M8946.06 1836c49.67 0 90 40.33 90 90s-40.33 90-90 90-90-40.33-90-90 40.33-90 90-90zm0 14.58c41.62 0 75.42 33.8 75.42 75.42 0 41.62-33.8 75.42-75.42 75.42-41.62 0-75.42-33.8-75.42-75.42 0-41.62 33.8-75.42 75.42-75.42zm32.76 32.35c3.88 2.95 7.36 6.43 10.31 10.31l-32.76 32.76 32.76 32.76a54.127 54.127 0 01-10.31 10.31l-32.76-32.76-32.76 32.76a54.127 54.127 0 01-10.31-10.31l32.76-32.76-32.76-32.76c2.95-3.88 6.43-7.36 10.31-10.31l32.76 32.76 32.76-32.76z"
            transform="translate(-8856.06 -1836)"
        ></path>
        </svg>
  );
}

export default IconCloseNotification;
